<template>
  <section class="section" v-touch:swipe.left="swipeLeftHandler" v-touch:swipe.right="swipeRightHandler">
    <div class="statistics">
      <h2 class="statistics__head">Исходы</h2>
      <ul class="statistics__list">
        <li class="statistics__item" v-for="(statistic, index) in statistics">
          <div class="statistics__title">{{ statistic.title }}</div>
          <ul>
            <li :class="{'correct':answers.correct === true}" v-for="answers in statistic.answer_option">
              <div v-if="answers.image">— <img :src="answers.image" alt="" title="" /></div>
              <div v-else>— {{ answers.title }}</div>
            </li>
            <li class="correct caption" v-if="statistic.sort === 13">
              * ВОПРОС СНИМАЕТСЯ и не учитывается в подсчете результатов в связи с реструктуризацией компании e-Legion
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="btn-group">
      <button class="btn btn--fb" v-on:click='doShare'>Рассказать в Facebook</button>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';

export default {
  data() {
    return {
      fbDescriptionNumber: '',
      fbTest: '123',
    }
  },
  mounted() {
    this.$store.dispatch('loadStatistic');
    this.$store.dispatch('loadShareDescription');
  },
  computed: {
    randomNumber() {
      return this.$route.params.randomNumber;
    },
    ...mapState([
      'statistics',
      'shareDescription',
      'shareDescriptionNumber',
    ])
  },
  methods: {
    swipeRightHandler() {
      this.$router.push('/');
    },
    swipeLeftHandler() {
      this.$router.push('/rating');
    },
    doShare() {
      FB.ui({
      method: 'share',
        hashtag: '#digitotal',
        href: document.location.protocol + '//' + document.location.host + '/statistics',
      }, function (response) {
        // Action after response
      });
    },
  },
};
</script>

<style lang="less">
.statistics {
  border-radius: 3rem;
  background-color: #02a654;
  box-shadow: 4px 4px 16px 0px rgba(0,0,0,1);
  width: 64rem;
  margin: 1.5rem auto 0;
  padding: 4rem;

  @media (max-width: 1023px) {
    width: 58rem;
  }

  @media (max-width: 767px) {
    width: 100%;
    padding: 1.5rem;
  }

  &__head {
    color: #fff;
    margin: 0 0 3rem;
    text-align: center;

    @media (max-width: 767px) {
      margin-bottom: 2rem;
    }
  }

  &__list {
    margin: 0;
    padding: 0;
  }

  &__item {
    list-style: none;
    color: #fff;
    font-size: 2rem;
    font-family: 'roboto-medium';
    line-height: 1.55;
    margin-bottom: 2rem;

    &:last-child {
      margin-bottom: 0;
    }

    ul {
      margin: 0;
      padding-left: 2.4rem;

      li {
        list-style: none;
        margin-bottom: 0.5rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #2f6f39;

        &:last-child {
          margin-bottom: 0;
        }

        img {
          width: 200px;
          margin-bottom: 1rem;
          margin-left: 1rem;
          opacity: 0.6;
        }

        &.correct {
          color: #fff;

          img {
            opacity: 1;
          }

          &.caption {
            font-size: 1rem;
          }
        }

        div {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      }
    }
  }

  &__title {
    margin-bottom: 1rem;
  }
}
</style>
